export const commonValues = {
  OTHER_OPTION_NECESSITY_ID: 854,
  PROGRAM_AREAS: {
    SERVICIO_SORDOS: 60,
    SERVICIO_CIEGOS: 59,
    EDUCACION_FISICA_ADAPTADA: 31,
    OTROS: 53,
    EDUCACION_FISICA_ADAPTADA_COMBINADA: 48,
    LENGUAJE_SENAS: 66,
    CONSEJERIA_REHABILITACION: 67
  },
};
